import React from 'react';
import styled, { css } from 'styled-components';
import { textGray } from '../utils/colors';

const StyledNoBook = styled.div`
  position: fixed;
  color: ${textGray};
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: ${props => props.theme.primary};
  z-index: 15;
  padding: 3rem;
  text-align: center;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const NoBook = ({ children }) => (
  <StyledNoBook inverted>
    {children ? (
      <h1>{children}</h1>
    ) : (
      <h1>
        For å få tilgang til <strong>Mitt Valgs Digitale Bøker</strong> trenger
        du en lenke til boken du vil lese.
      </h1>
    )}
  </StyledNoBook>
);

export default NoBook;



// WEBPACK FOOTER //
// ./src/components/NoBook.js